import { render, staticRenderFns } from "./AvatarWithAvailability.vue?vue&type=template&id=2dbb920a&scoped=true"
import script from "./AvatarWithAvailability.vue?vue&type=script&lang=js"
export * from "./AvatarWithAvailability.vue?vue&type=script&lang=js"
import style0 from "./AvatarWithAvailability.vue?vue&type=style&index=0&id=2dbb920a&prod&lang=css"
import style1 from "./AvatarWithAvailability.vue?vue&type=style&index=1&id=2dbb920a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbb920a",
  null
  
)

export default component.exports